import HeaderDashboard from "../../Components/HeaderDashboard";
import React, { useEffect, useState, useRef, useContext } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { AuthContext } from "../../Routes/AuthProvider";
import {
  getBookingDetailById,
  hotelCancel,
  retrieveHotelBooking,
} from "../../Services/HotelSearchApi";

const HotelCancellationBooking = () => {
  const { userName, roles } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const referenceNo =
    queryParams.get("ReferenceNo") || queryParams.get("refernceno");

  const [bookingDetails, setBookingDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const [comments, setComments] = useState("");
  const [selectedTickets, setSelectedTickets] = useState([]);

  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [cancellationCharges, setCancellationCharges] = useState(null);
  const [cancelLoading, setCancelLoading] = useState(false);

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    if (referenceNo) {
      hasFetched.current = true;
      fetchHotelBookingDetails(referenceNo);
    } else {
      console.warn("Missing referenceNo");
    }
  }, [referenceNo]);

  const fetchHotelBookingDetails = async (refId) => {
    try {
      setLoading(true);
      setError("");
      let response = await getBookingDetailById(refId);
      if (Array.isArray(response) && response.length > 0)
        response = response[0];

      if (response && response.booking) {
        setBookingDetails(response.booking);
      } else if (response && response.Booking) {
        setBookingDetails(response.Booking);
      } else if (response && response.pkid) {
        setBookingDetails(response);
      } else {
        setError("Booking details not found.");
      }
    } catch (err) {
      console.error("Error fetching hotel details:", err);
      setError("Failed to load hotel booking details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePassengerSelect = (ticketIndex) => {
    setSelectedTickets((prev) => {
      if (prev.includes(ticketIndex)) {
        return prev.filter((id) => id !== ticketIndex);
      } else {
        return [...prev, ticketIndex];
      }
    });
  };

  const CancelledMyBooking = async () => {
    if (!cancelReason) {
      alert("Please select cancellation reason");
      return;
    }
    // Show cancellation charges popup
    setCancellationCharges({
      cancellationPolicyJson: bookingDetails?.rooms?.[0]?.cancellationPolicyJson || "[]",
    });

    setShowCancelPopup(true);
  };

  const ConfirmCancellation = async () => {
    try {
      setCancelLoading(true);
      setLoading(true);
      const payload = {
        traceId: bookingDetails.traceID || "",
        confirmationNo: bookingDetails.confirmationNo || "",
        bookingRefId: bookingDetails.bookingRefId || "",
        key: bookingDetails.providerName || "",
        supplierParameter: bookingDetails.supplierParameter || "",
        remarks: comments || "",
        cancelationReason: cancelReason || "",
        cancelledBy: userName
      };

      const response = await hotelCancel(payload);

      if (
        response &&
        (response.cancellationStatus === "CANCELLED" ||
          response.cancellationStatus === "CANCELLATION_PENDING" ||
          response.status === "success")
      ) {
        try {
          const retrievePayload = {
            traceId: bookingDetails.traceID || "",
            bookingRefId: bookingDetails.bookingRefId || "",
            confirmationNo: bookingDetails.confirmationNo || "",
            key: bookingDetails.providerName || "",
            supplierParameter: bookingDetails.supplierParameter || "",
          };

          await retrieveHotelBooking(retrievePayload);
        } catch (retrieveError) {
          console.warn("Retrieve booking after cancel failed:", retrieveError);
        }

        setShowCancelPopup(false);

        alert("Booking cancelled successfully");

        navigate(
          `/Reservations/Hotel/TransactionsDetails?referenceno=${referenceNo}`,
        );
      } else {
        alert(response?.message || "Cancellation failed. Please try again.");
      }
    } catch (error) {
      console.error("Cancellation Error:", error);
      alert(
        error.response?.data?.message ||
          "Cancellation failed. Please check the logs.",
      );
    } finally {
      setCancelLoading(false);
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <>
      {loading && (
        <p className="text-center load">
          <span className="loader"></span>
        </p>
      )}
      <HeaderDashboard />
      <div className="toolbar py-2" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className="container-fluid d-flex align-items-center"
        >
          <div className="flex-grow-1 flex-shrink-0 me-5">
            <div className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
              <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">
                Reservations
              </h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li className="breadcrumb-item text-muted">Hotel</li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-gray-900">
                  Cancellation Booking
                </li>
              </ul>
            </div>
          </div>
          <div className="d-flex align-items-center flex-wrap">
            <div className="flex-shrink-0">
              <ul className="nav" role="tablist">
                <li className="nav-item">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      window.history.back();
                    }}
                  >
                    <img src="/assets/images/back.png" className="imgBack" alt="Back" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section className="wraper">
        <div className="box_shadow mt-14">
          <div className="row">
            {bookingDetails ? (
              <>
                <div className="row mamage_depo">
                  <div className="col-lg-12">
                    <h6 className="ruler">Hotel Booking Details</h6>
                  </div>
                </div>
                <div className="col-md-12 col-lg-12">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Reference No</th>
                          <th>Confirmation Number</th>
                          <th>Booking Status</th>
                          <th>Booking Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{bookingDetails.bookingRefId}</td>
                          <td>{bookingDetails.confirmationNo}</td>
                          <td>
                            {(() => {
                              const status = (bookingDetails.bookingStatus || "").toUpperCase();
                              let badgeClass = "bg-secondary";
                              if (status === "CONFIRMED" || status === "SUCCESS" || status === "BOOKING CONFIRMED") badgeClass = "bg-success";
                              else if (["PENDING", "HOLD", "ON_HOLD", "CANCELLATION_PENDING", "APPROVE_PENDING"].includes(status)) badgeClass = "bg-warning";
                              else if (["FAILED", "CANCELLED", "APPROVE_REJECTED"].includes(status)) badgeClass = "bg-danger";
                              return (
                                <span className={`badge ${badgeClass} text-white fw-bold px-3 py-1.5`} style={{ textTransform: "uppercase" }}>
                                  {status || "-"}
                                </span>
                              );
                            })()}
                          </td>
                          <td>
                            {new Date(bookingDetails.createdAt).toLocaleString(
                              "en-IN",
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-md-12 col-lg-12">
                  <h6 className="ruler">Stay Information</h6>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Hotel Name</th>
                          <th>Room Name</th>
                          <th>City</th>
                          <th>Check-In</th>
                          <th>Check-Out</th>
                          <th>Nights / Rooms</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="fw-bold">
                            {bookingDetails.hotelName}
                          </td>
                          <td>
                            {bookingDetails.rooms?.map((room, idx) => (
                              <div key={idx} className="fw-semibold">
                                {room.roomName}
                              </div>
                            )) || "-"}
                          </td>
                          <td>{bookingDetails.cityName}</td>
                          <td>{formatDate(bookingDetails.checkInDate)}</td>
                          <td>{formatDate(bookingDetails.checkOutDate)}</td>
                          <td>
                            {bookingDetails.noOfNights} Night(s) /{" "}
                            {bookingDetails.noOfRooms} Room(s)
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-lg-12 mt-4">
                  <h6 className="ruler">Passenger Details</h6>
                </div>
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Type</th>

                          <th>PAN No</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bookingDetails.rooms?.map((room, rIdx) =>
                          room.paxDetails?.map((pax, pIdx) => (
                            <tr key={`${rIdx}-${pIdx}`}>
                              <td>
                                {pax.title}. {pax.firstName} {pax.lastName}{" "}
                                {pax.isLeadGuest && (
                                  <span className="badge bg-info ms-1">
                                    Lead
                                  </span>
                                )}
                              </td>
                              <td>{pax.paxType}</td>

                              <td>{pax.panNumber || "-"}</td>
                              <td>{bookingDetails.bookingStatus}</td>
                            </tr>
                          )),
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col-md-12 mb-3 mt-4 remrk">
                  <h6 className="ruler">
                    Cancellation Reason <span className="required"></span>
                  </h6>
                  {[
                    "Change in travel plans",
                    "Medical emergency",
                    "Personal emergency",
                    "Incorrect booking",
                    "Duplicate booking",
                    "Visa issues",
                    "Bad weather",
                    "Work commitments",
                    "Other",
                  ].map((reason, idx) => (
                    <div className="form-check mt-2" key={idx}>
                      <input
                        type="radio"
                        className="form-check-input"
                        name="cancelReason"
                        value={reason}
                        checked={cancelReason === reason}
                        onChange={(e) => setCancelReason(e.target.value)}
                        disabled={loading}
                      />
                      <label className="form-check-label">{reason}</label>
                    </div>
                  ))}
                </div>

                <div className="col-md-12 mt-3">
                  <label className="fw-bold mb-2">Write Comments</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    placeholder="Write comments..."
                    disabled={loading}
                  />
                </div>

                <div className="col-md-12 mt-4 text-end">
                  <button
                    type="button"
                    className="btn btn-primary d-inline-flex align-items-center"
                    onClick={CancelledMyBooking}
                    disabled={loading}
                    style={{ backgroundColor: "#1a1a3c", border: "none" }}
                  >
                    {loading ? (
                      <>
                        <i className="fa fa-spinner fa-spin me-2"></i>
                        Cancelling...
                      </>
                    ) : (
                      "Proceed"
                    )}
                  </button>
                </div>
              </>
            ) : (
              <div className="col-lg-12 text-center p-5">
                {loading ? (
                  <div className="d-flex flex-column align-items-center">
                    <i className="fa fa-spinner fa-spin fa-2x text-primary mb-3"></i>
                    <h6 className="text-muted">Loading booking details...</h6>
                  </div>
                ) : (
                  <h6 className="text-muted">No Booking Details Found.</h6>
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      {showCancelPopup && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">

              {/* Header */}
              <div className="modal-header">
                <h5 className="modal-title">
                  Cancellation Policy
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCancelPopup(false)}
                />
              </div>

              {/* Body */}
              <div className="modal-body">

                <div className="mb-3">
                  <h6 className="fw-bold mb-1">
                    {bookingDetails?.booking?.hotelName}
                  </h6>

                  <small className="text-muted">
                    Booking Ref:{" "}
                    {bookingDetails?.booking?.bookingRefId}
                  </small>
                </div>

                <div className="alert alert-warning">
                  <strong>
                    Are you sure you want to cancel this booking?
                  </strong>
                  <br />
                  Please review the cancellation charges below before
                  confirming.
                </div>

                <div className="table-responsive">
                  <table className="table table-bordered align-middle">

                    <thead className="table-light">
                      <tr>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>Cancellation Charge</th>
                        <th>Charge Type</th>
                      </tr>
                    </thead>

                    <tbody>
                      {(() => {
                        let policies = [];

                        try {
                          policies = JSON.parse(
                            cancellationCharges?.cancellationPolicyJson || "[]"
                          );
                        } catch (error) {
                          console.error(
                            "Invalid cancellation policy JSON:",
                            error
                          );
                        }

                        if (!policies.length) {
                          return (
                            <tr>
                              <td
                                colSpan="4"
                                className="text-center text-muted"
                              >
                                No cancellation policy available.
                              </td>
                            </tr>
                          );
                        }

                        return policies.map((policy, index) => (
                          <tr key={index}>

                            <td>
                              {policy.fromDate || "-"}
                            </td>

                            <td>
                              {policy.toDate || "-"}
                            </td>

                            <td>
                              <strong>
                                {policy.currency || "INR"}{" "}
                                {Number(
                                  policy.penaltyAmount || 0
                                ).toFixed(2)}
                              </strong>
                            </td>

                            <td>
                              {policy.chargeType || "-"}
                            </td>

                          </tr>
                        ));
                      })()}
                    </tbody>

                  </table>
                </div>

                <div className="mt-3">
                  <strong>Cancellation Reason:</strong>
                  <div className="text-muted">
                    {cancelReason}
                  </div>
                </div>

                {comments && (
                  <div className="mt-2">
                    <strong>Remarks:</strong>
                    <div className="text-muted">
                      {comments}
                    </div>
                  </div>
                )}

              </div>

              {/* Footer */}
              <div className="modal-footer">

                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowCancelPopup(false)}
                >
                  Close
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={ConfirmCancellation}
                  disabled={loading}
                >
                  {loading
                    ? "Cancelling..."
                    : "Cancel Ticket"}
                </button>

              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HotelCancellationBooking;
